import React from "react";
import "./style.css";
import Header1 from "./Components/Header1";
import Team1 from "./Components/Team1";
import Footer1 from "./Components/Footer1";
import Services1demo from "./Components/Services1demo";
import Ourwork1 from "./Components/Ourwork1";
import Achievement from "./Components/Achievement";
import Appointment from "./Components/Appointment";
import partner1 from "./Images/partner-1.jpg";
import partner2 from "./Images/partner-2.jpg";
import partner3 from "./Images/partner-3.jpg";
import partner4 from "./Images/partner-4.jpg";
import "./Components/flaticon.css";
import Welcome1 from "./Components/Welcome1";
import Testimonial from "./Components/Testimonial";
import Gallery from "./Components/Gallery";
import Offer from "./Components/Offer";
import Loader from "./Components/Loader";
import PopOffer from "./Components/Popoffer";

const DemoPage=()=>{
    return(
        <>
            <Header1/>
                <Welcome1/>
                <Services1demo/>
                <Team1/>
                <Ourwork1/>
            <Footer1/>
        </>
    );
}

export default DemoPage;